export const en = {
    default: {
        search: 'SEARCH',
        confirm: 'CONFIRM',
    },
    date: {
        days: 'day',
        months: 'month',
        years: 'year',
        minutes: 'minute',
        minutes_short: 'min',
        hours: 'hour',
        hours_short: 'hr',
        date_flase: 'Please select your birthday.',
        month_full: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        month_short: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        month_full_arr: [{ strvalue: "01", strtext: 'January' },
        { strvalue: '02', strtext: 'February' },
        { strvalue: '03', strtext: 'March' },
        { strvalue: '04', strtext: 'April' },
        { strvalue: '05', strtext: 'May' },
        { strvalue: '06', strtext: 'June' },
        { strvalue: '07', strtext: 'July' },
        { strvalue: '08', strtext: 'August' },
        { strvalue: '09', strtext: 'September' },
        { strvalue: '10', strtext: 'October' },
        { strvalue: '11', strtext: 'November' },
        { strvalue: '12', strtext: 'December' }]
    },
    redeem_button: {
        default: 'Redeem',
        none: '',
        soldOut: 'Sorry, This reward is reaching redemption limit.',
        soldOutBuy: 'Sorry, This reward is reaching redemption limit.',
        maxPerPerson: 'Sorry, You have already redeemed this reward.',
        redeemCoolDown: 'This campaign has been used for this period.',
        nextDate: '<br/>at : ',
        exceedBuyPointLimitPerday: '',
        conditionIsInvalid: 'This campaign requires user action before redemption, please review the conditions first.',
        campaignExpired: 'Campaign has expired.',
        campaignExpiredBuy: 'Campaign has expired.',
        campaignNotAvailable: 'Sorry. This reward is not available',
        campaignNotAvailableBuy: 'Sorry. This product is not available',
        notEnoughPoint: 'Your point are not enough to redeem this campaign.',
        notSupport: 'This campaign is not support.',
        specialEvent: 'อ่านรายละเอียด'
    },
    confirm_redeem: {
        confirm: "Confirm",
        cancel: "Cancel",

        headline: 'กรุณากดยืนยันเพื่อรับสิทธิ์',
        free: 'Serial will available for {0} after confirm',
        free_no_timer: 'Confirm to redeem',
        free_delivery: 'Please enter shipping information to redeem',
        draw: 'Confirm to join campaign <br/> Winner will be announced after {0}',
        draw_delivery: 'Please enter shipping information to redeem',
        deal: 'Serial will available for {0} after confirm',
        deal_no_timer: 'Confirm to redeem',
        deal_delivery: 'Please enter shipping information to redeem',
        buy: 'Confirm to purchase',
        buy_delivery: 'Please enter shipping information to buy',
        interface: 'This will redirect to website after confirm',
    },
    purchase: {
        show_code: 'view code',
        code_expired: 'This serial has expired.',

        delivery: 'Product will be mailed based on Campaign Condition.',
        shipped: 'The Product has been delivered.',
        parcel_no: 'ParcelNo',

        not_draw1: 'Not yet drawn,',
        not_draw2: 'please check back at a later date',
        draw_winner1: 'You are the winner',
        draw_winner2: '',
        draw_not_win1: 'Sorry you are not the winner,',
        draw_not_win2: 'better luck next',
    },
    serial: {
        close_btn: 'Close',
        show_code_at_shop: 'Please show code below to claim your privilege.',

        delivery: 'Product will be mailed based on Campaign Condition.',

        draw: 'Thank you for joining us.<br/>Winner will be announced after {0}',
        draw_after: 'after',

        qr_code: 'QR Code',
        barcode: 'Barcode',
        code: 'Code',

        expire_in: 'Expire in ',
        code_expired: 'This serial has expired.',

        redeem_on: 'Redeem on {0}'
    },
    register: {
        firstname_th: {
            name: 'ชื่อภาษาไทย (ไม่ต้องมีคำนำหน้า)',
            placeholder: '',
            required: 'กรุณากรอกชื่อ ภาษาไทย',
            too_short: '',
            invalid: '',
        },
        lastname_th: {
            name: 'นามสกุล ภาษาไทย',
            placeholder: '',
            required: 'กรุณากรอกนามสกุล ภาษาไทย',
            too_short: '',
            invalid: '',
        },
        firstname_en: {
            name: 'First name English',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        lastname_en: {
            name: 'Last name English',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
        },
        contact_number: {
            name: 'เบอร์โทรศัพท์',
            name2: '(โดยไม่กรอกเลข 0 นำหน้า)',
            placeholder: '',
            required: 'กรุณากรอกเบอร์โทรศัพท์',
            too_short: '',
            invalid: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง',
        },
        birthdate: {
            name: 'วันเกิด',
            placeholder: '',
            required: '',
            too_short: '',
            invalid: '',
            age_consent: "คุณต้องมีอายุอย่างน้อย 20 ปีขึ้นไป จึงสามารถเข้าใช้งานได้",
            required_all: 'กรุณากรอก วัน/เดือน/ปี ให้ครบถ้วน',
        },
        country: {
            name: 'ถิ่นที่อยู่อาศัย',
            placeholder: '',
            required: 'กรุณากรอกวันเกิด',
            too_short: '',
            invalid: '',
        },
        day: "วัน",
        month: "เดือน",
        year: "ปี",
        mising_boutiqueID: "พบปัญหาการเชื่อมต่อ กรุณาสแกน QR Code หรือกดลิงก์เพื่อลงทะเบียนอีกครั้ง"
    },
    shipping: {
        headline: 'Shipping address',

        firstname: {
            name: 'Firstname',
            placeholder: 'Firstname',
            required: 'Please enter firstname',
            too_short: '',
            invalid: '',
        },
        lastname: {
            name: 'Lastname',
            placeholder: 'Lastname',
            required: 'Please enter lastname',
            too_short: '',
            invalid: '',
        },
        address:  {
            name: 'Address',
            placeholder: 'Address',
            required: 'Please enter address',
            too_short: '',
            invalid: '',
        },
        contactnumber: {
            name: 'Contact number',
            placeholder: 'Contact number',
            required: 'Contact number',
            too_short: 'Contact number must be {0} digits',
            invalid: 'Incorrect contact number format',
        },
        nationalid: {
            name: 'National id',
            placeholder: 'National id',
            required: 'Please enter national id',
            too_short: 'National id number must be {0} digits',
            invalid: 'Incorrect national id format',
        },
        email: {
            name: 'Email',
            placeholder: 'Email',
            required: 'Please enter email address',
            too_short: '',
            invalid: 'Incorrect email format',
        },
        zipcode: {
            name: 'Zipcode',
            placeholder: 'Zipcode',
            required: 'Please enter zipcode',
            too_short: 'Zipcode must be {0} digits',
            invalid: 'Invalid zipcode',
        },
        subdistrict: {
            name: 'Sub district',
            placeholder: 'Please selece sub-district',
            required: 'Please selece sub-district',
            too_short: '',
            invalid: '',
        },
        district: {
            name: 'District',
            placeholder: 'Please selece district',
            required: 'Please selece district',
            too_short: '',
            invalid: '',
        },
        province: {
            name: 'Province',
            placeholder: 'Please selece province',
            required: 'Please selece province',
            too_short: '',
            invalid: '',
        },

        save_address: 'Save address for next privilege',
        save_address_buy: 'Save address for next puchase',

        confirm_btn: 'Confirm',
        cancel_btn: 'Cancel',

        alert_headline: 'Shipping address',
        alert_ok_btn: 'OK',
    },
    main: {
        home_page: "Home",
        login: "Login",
        campaign: "Campaign",
        category: 'Category',
        map: "Map",
        history: 'History',
        profile: "Profile",
        logout: "Logout",
        lang: "Language",
        msgLogout: "Logout ?",
        cancel: "Cancel",
    },
    campaign: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
    },
    detail: {
        detail: 'Details',
        condition: 'Conditions',

        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',
        available_date: 'Date',

        color: {
            name: 'Color',
            placeholder: 'Please select color',
            required: 'Please select color',
        },
        size: {
            name: 'Size',
            placeholder: 'Please select size',
            required: 'Please select size',
        },
    },
    history: {
        point: 'Point',
        get_point: 'Get Point : ',
        use_point: 'Use Point : ',

        parcel_number: 'Parcel No. : ',
    },
    otp: {
        headline: 'รหัสยืนยันตัวตน',
        line1: "กรุณากรอกรหัส OTP ตามที่ท่านได้รับจาก <br/> SMS ที่ส่งไปยังเบอร์ที่ท่านได้ให้ข้อมูลไว้ เพื่อยืนยันตัวตน",
        line2: 'รหัส OTP',

        resend_line1: 'เวลาใช้รหัส : ',
        resend_line3: 'รหัสใช้ครั้งเดียวหมดอายุ',
        resend_line2: 'ส่งอีกครั้ง',

        otp_is_empty: 'Please input OTP',
        otp_is_not_correct: 'รหัสใช้ครั้งเดียวไม่ถูกต้อง', //'OTP is not correct',
        otp_already_register: 'This mobile no. has already registered',

        headline_error: 'ลงทะเบียนไม่สำเร็จ',
        msg_error: 'ขออภัย การลงทะเบียนล้มเหลว<br/>กรุณาลองใหม่อีกครั้ง',
        invalid_otp_error: 'User did not input the correct OTP',
        again: 'ลองใหม่อีกครั้ง',
        register_limit: 'The user has reached the maximum attempts on OTP (5 times in total)',
        register_time: 'The user fail to complete the registration within time limit.',
        time_left1: 'รหัสจะหมดอายุภายใน',
        newregis: 'ลงทะเบียนใหม่',
        otp_expire: 'รหัสหมดอายุ กรุณาลองใหม่อีกครั้ง',
        register_error: "สมัครสมาชิกไม่สำเร็จ รบกวนลองใหม่อีกครั้ง",
        close: "ปิด",
    },
    maintena: {
        title: "งดให้บริการชั่วคราว",
        text: "ขณะนี้ระบบบัญชี LINE ของเราอยู่ในระหว่างการอัปเดต </br> ระบบเพื่อมอบประสบการณ์ที่ดีที่สุดสำหรับคุณ </br> กรุณาลองใหม่ในภายหลัง",
        btn_text: "เข้าสู่ CHANEL.COM"
    }
};
